export const CommunitiesEndpoints = {
  getCommunity: (communityId: number) =>
    `${process.env.CONTENT_URL}/rest/v1/communities/${communityId}`,
  getCommunityBySlug: (communitySlug: string) =>
    `${process.env.CONTENT_URL}/rest/public/v1/communities/url/${communitySlug}`,
  getAllCommunities: () => `${process.env.CONTENT_URL}/rest/v1/communities`,
  putCoverImage: (id: number) => `${process.env.CONTENT_URL}/rest/v1/communities/admin/${id}`,
  putBanMember: (collectionId: number) => `/rest/v1/collections/${collectionId}/blockFollower`,
  getCommunityAssociatedCourseStatus: (communityId: number) =>
    `${process.env.CONTENT_URL}/rest/v1/communities/admin/${communityId}/product/access`,
  getCommunityAssociatedCourseStatusPublic: (communityId: number) =>
  `${process.env.CONTENT_URL}/rest/public/v2/communities/${communityId}/product/access`,
  getMyCommunities: () => `${process.env.BASE_URL}/rest/v1/membership/communities/highlighted`
};
